import React, { useEffect } from "react";
import Header2 from "../Header2/header2";
import Footer from "../Footer/footer";
import Requestalisting from "../Request a listing/Requestalisting";
import ListaBusiness from "../List a Business/ListaBusiness";
import { useHistory } from 'react-router-dom';


const Dashboard = () => {
  const token = localStorage.getItem("token")
  

  const history = useHistory();
 

  useEffect(() => {
    if (token === undefined || token ==="undefined" || token === null || token === "") {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      history.push('/login');
    }
  }, []);

  const fname = JSON.parse(localStorage.getItem("fname"));

  
  



  return(
<>
<Header2/>
<section className="dash_welcome">
<div className="container">
   <div className="row mb-5">
      <div className="col text-center">
      <h2 className="h2_medum" >Welcome <span className='color-9F7854 user-name fw-bold'>{fname}</span></h2>
               <p>We are happy to see you again <br/>Please select one of the following options to continue. </p>

      </div>
   </div>
   <div className="row">
     <div className="col-lg-6 mb-4">
     <Requestalisting/>
     </div>
     <div className="col-lg-6 mb-4">
     <ListaBusiness/>
     </div>
   </div>
</div>
</section>
<Footer/>
</>
  )}
export default Dashboard;